import React, { Component } from "react";

import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CSpinner
} from "@coreui/react";
import { connect } from "react-redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import Literarte from "../SlateComponents/Literarte";
import ViewCorrectionLiterarte from "../ViewCorrectionLiterarte";

import "./style.css";

const CloseModal = props => (
  <CModal
    show={props.show}
    onClose={props.onClose}
    closeOnBackdrop={false}
    centered
  >
    <CModalHeader closeButton>
      <CModalTitle>Sair</CModalTitle>
    </CModalHeader>
    <CModalBody>
      <span className="p-3">
        Deseja sair do Literarte sem salvar as mudanças?
      </span>
    </CModalBody>
    <CModalFooter>
      <CButton color="primary" className="mr-2" onClick={props.onQuit}>
        Sair
      </CButton>
      <CButton color="secondary" onClick={props.onClose}>
        Cancelar
      </CButton>
    </CModalFooter>
  </CModal>
);

class LiterarteModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      activity: null,
      production: null,
      closeModal: false
    };
  }

  async componentDidMount() {
    const res = await axios.get(
      `${URL.api}literarte/activity/singleView/${this.props.id}`,
      { headers: { Authorization: `Bearer ${this.props.user.token}` } }
    );

    this.setState({
      activity: res.data.data
    });

    let obj = {
      id: this.props.id,
      user_id: this.props.user_id
    };

    axios
      .post(`${URL.api}literarte/production/singleView`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.data) {
            const text = JSON.parse(resp.data.data.pages[0].content);
            this.props.onChange(text);

            this.setState({
              production: resp.data.data
            });
          } else {
            const text = [
              {
                type: "paragraph",
                children: [{ text: "" }]
              }
            ];

            this.props.onChange(text);
          }

          this.setState({
            loading: false
          });
        },
        err => {
          const text = [
            {
              type: "paragraph",
              children: [{ text: "" }]
            }
          ];

          this.props.onChange(text);

          this.setState({
            loading: false
          });
        }
      );
  }

  openCloseModal() {
    if (this.state.production?.value || this.props.late) {
      this.props.onClose();
    } else {
      this.setState({ closeModal: true });

      /* eslint-disable no-throw-literal */
      throw "";
    }
  }

  render() {
    if (this.props.hideModal) {
      return (
        <div className="w-100 h-100 d-flex overflow-auto">
          {this.state.loading ? (
            <div className="h-100 w-100 d-flex align-items-center justify-content-center">
              <CSpinner size="md" color="secondary" />
            </div>
          ) : (
            <Literarte
              activity={this.state.activity}
              value={this.props.value}
              edit
              onChange={value => this.props.onChange(value)}
              saveTextProduction={pages => this.props.saveTextProduction(pages)}
              placeholder="Digite aqui"
              production={this.state.production}
              hideSaveButton={this.props.hideSaveButton}
            />
          )}
        </div>
      );
    }

    return (
      <CModal
        show={this.props.show}
        onClose={e => this.openCloseModal(e)}
        size="lg w-100 h-100 m-0 p-2 mw-100"
        style={{ width: "100%", height: "100%" }}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton={!this.props.hideSaveButton}>
          <CModalTitle>{this.props.title}</CModalTitle>
          {this.props.hideSaveButton && (
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => this.props.disableLiterarteModal()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          )}
        </CModalHeader>
        <CModalBody className="p-0 d-flex" style={{ overflow: "auto" }}>
          {this.state.loading ? (
            <div className="h-100 w-100 d-flex align-items-center justify-content-center">
              <CSpinner size="md" color="secondary" />
            </div>
          ) : !this.state.production?.value ? (
            <Literarte
              activity={this.state.activity}
              value={this.props.value}
              onChange={value => this.props.onChange(value)}
              saveTextProduction={pages => this.props.saveTextProduction(pages)}
              placeholder="Digite aqui"
              edit={!this.props.late}
              production={this.state.production}
              hideSaveButton={this.props.hideSaveButton}
            />
          ) : (
            <ViewCorrectionLiterarte
              activity={this.state.activity}
              value={this.props.value}
              production={this.state.production}
            />
          )}
          <CloseModal
            show={this.state.closeModal}
            onQuit={() =>
              this.setState({ closeModal: false }, () => this.props.onClose())
            }
            onClose={() => this.setState({ closeModal: false })}
          />
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({ user: state.user });

export default connect(mapStateToProps, null)(LiterarteModal);
